import {
  Airtime_icon,
  Cabletv_icon,
  Data_icon,
  Education_icon,
  Electricity_icon,
  Government_icon,
  Insurance_icon,
  Pension_icon,
  Ticket_icon,
  betting_icon,
} from "@/assets";
import { PAYMENTS_DATA_TYPE } from "@/models";
import { Book1, Call, Game, LampCharge, Monitor, Ticket, Wifi } from "iconsax-react";
import { HOME_PAGE_ROUTES } from "./page";

export const billPayment = [
  { id: 1, logo: Cabletv_icon, title: "cable Tv", link: "/" },
  { id: 2, logo: Electricity_icon, title: "Electricity", link: "/" },
  { id: 3, logo: Insurance_icon, title: "Insurance", link: "/" },
  { id: 4, logo: Airtime_icon, title: "Airtime", link: "/" },
  { id: 5, logo: Data_icon, title: "Data", link: "/" },
  { id: 6, logo: Education_icon, title: "Education", link: "/" },
  { id: 7, logo: Pension_icon, title: "Pension", link: "/" },
  { id: 8, logo: Ticket_icon, title: "Ticket", link: "/" },
  { id: 9, logo: betting_icon, title: "Betting", link: "/" },
  { id: 10, logo: Government_icon, title: "Government", link: "/" },
];

export const CableTVMonthOptions = [
  {
    label: "1 Month",
    value: 1,
  },
  {
    label: "2 Months",
    value: 2,
  },
  {
    label: "3 Months",
    value: 3,
  },
  {
    label: "4 Months",
    value: 4,
  },
  {
    label: "5 Months",
    value: 5,
  },
  {
    label: "6 Months",
    value: 6,
  },
  {
    label: "7 Months",
    value: 7,
  },
  {
    label: "8 Months",
    value: 8,
  },
  {
    label: "9 Months",
    value: 9,
  },
  {
    label: "10 Months",
    value: 10,
  },
  {
    label: "11 Months",
    value: 11,
  },
  {
    label: "12 Months",
    value: 12,
  },
];

export const BillPaymentsEssentials: PAYMENTS_DATA_TYPE[] = [
  {
    name: "Airtime",
    icon: (
      <div className="p-4 rounded-full bg-[#FFF4EC]">
        <Call color="#FF6D00" />
      </div>
    ),
    to: HOME_PAGE_ROUTES.AIRTIME
  },
  {
    name: "Data",
    icon: (
      <div className="p-4 rounded-full bg-[#E9FAE9]">
        <Wifi color="#006F01" />
      </div>
    ),
    to: HOME_PAGE_ROUTES.DATA
  },
  {
    name: "Cable Tv",
    icon: (
      <div className="p-4 rounded-full bg-[#E4F3FC]">
        <Monitor color="#00426A" />
      </div>
    ),
    to: HOME_PAGE_ROUTES.CABLE_TV
  },
  {
    name: "Electricity",
    icon: (
      <div className="p-4 rounded-full bg-[#FFF7DC]">
        <LampCharge color="#CA9E01" />
      </div>
    ),
    to: HOME_PAGE_ROUTES.ELECTRICITY
  },
  {
    name: "Education",
    icon: (
      <div className="p-4 rounded-full bg-[#E4F3FC]">
        <Book1 color="#00426A" />
      </div>
    ),
    to: HOME_PAGE_ROUTES.EDUCATION
  },
  {
    name: "Betting",
    icon: (
      <div className="p-4 rounded-full bg-[#E9EFF8]">
        <Game color="#292D32" />
      </div>
    ),
    to: HOME_PAGE_ROUTES.BETTING
  },
  {
    name: "Tickets",
    icon: (
      <div className="p-4 rounded-full bg-[#F0FCD6]">
        <Ticket color="#76AD00" />
      </div>
    ),
    to: HOME_PAGE_ROUTES.AIRTIME
  },
];